import merge from "lodash/merge";
import cloneDeep from "lodash/cloneDeep";
import { generalTokens } from "./general.tokens.js";
const vkTokens = merge(cloneDeep(generalTokens), {
    name: 'vk',
    colors: {
        original: {
            brand: {
                primary: '#2688eb',
                secondary: '#edf3ff',
                tertirary: '#167de4',
                quaternary: '#d8e5ff'
            }
        },
        accent: {
            stroke: {
                blue: '#b8cefa'
            }
        }
    }
});
export { vkTokens };
